import { useEffect, useState } from 'react';
import { Plan, useCurrentAgreement } from '@economic/react-app';

export const useHasGraveyardFeaturePermission = () => {
    const agreement = useCurrentAgreement();
    const [hasAccess, setHasAccess] = useState<boolean | undefined>(undefined);

    useEffect(() => {
        const planLevel = agreement?.subscription?.level;
        setHasAccess(
            !agreement.modules.inventory && (planLevel === Plan.Smart || planLevel === Plan.Advanced || planLevel === Plan.Plus)
        );
    }, [agreement]);

    return hasAccess;
};
